import React from 'react';
import PropTypes from 'prop-types';
import { Snackbar as MuiSnackbar, SnackbarContent as MuiSnackbarContent } from '@mui/material';
import { withStyles } from '@mui/styles';

const contentStyles = {
  message: {
    width: '100%',
    textAlign: 'center',
  },
};

const SnackbarContent = withStyles(contentStyles)(MuiSnackbarContent);

export function Snackbar({
  className, open, message, autoHideDuration, onClose,
}) {
  return (
    <MuiSnackbar
      className={className}
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
    >
      <SnackbarContent message={message} />
    </MuiSnackbar>
  );
}

Snackbar.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool,
  message: PropTypes.node,
  autoHideDuration: PropTypes.number,
  onClose: PropTypes.func,
};
